const POLICY_TERMS = [{
  value: 12,
  label: '12 Month'
}, {
  value: 6,
  label: '6 Month'
}, {
  value: 4,
  label: '4 Month'
}, {
  value: 3,
  label: '3 Month'
}, {
  value: 2,
  label: '2 Month'
}, {
  value: 1,
  label: '1 Month'
}, {
  value: 120,
  label: '120 Month (10 yr)'
}, {
  value: 180,
  label: '180 Month (15 yr)'
}, {
  value: 240,
  label: '240 Month (20 yr)'
}, {
  value: 300,
  label: '300 Month (25 yr)'
}, {
  value: 360,
  label: '360 Month (30 yr)'
}];

export { POLICY_TERMS as P };
